import { useEffect } from 'react';

import { useConsentStatus } from '@/ampli';
import { initLinkedInInsight } from '@/utils/linkedin-insight';

/**
 * Initialises the LinkedIn Insight Tag once the user has accepted cookies.
 * Consent status reacts to both a returning consented visitor and a fresh
 * "Accept" click.
 */
const LinkedInInsightTag = () => {
  const isOptedIn = useConsentStatus() === 'optedIn';

  useEffect(() => {
    if (isOptedIn) {
      initLinkedInInsight();
    }
  }, [isOptedIn]);

  return null;
};

export default LinkedInInsightTag;
